const colors = {
  PRIMARIA: "#51BAA2",
  SECUNDARIA: "#CCCCCC",
  BACKGROUND: "#FFFFFF",
  BACKGROUNDALT: "#F2F1F0",
  FONTEPADRAO: "#000000",
  FONTEALT: "#8f8f8f",
  ERROR: "#E72424",
  SUCCESS: "#15B138",
};

export default colors;
